import api from "./api";

export default class ReservationApi {
  static async Post(data) {
    return await api.post(`reservation`, data);
  }
}
